module.exports = __webpack_public_path__ + "static/media/sigerh_screenshot.10f6c2e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/sigerh_screenshot.png
// module id = 239
// module chunks = 0